module.exports = __webpack_public_path__ + "static/media/fondo_animador.a950dc04.jpg";